import React from 'react';
import classNames from 'classnames';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';
import type { FCWithChildren } from '../../types/FCWithChildren';

export interface IBadgeTWProps extends IHasTestData {
  className?: string;
}

export const BadgeTW: FCWithChildren<IBadgeTWProps> = ({ children, className, 'data-test-id': dataTestId }) => (
  <span
    data-test-id={mergeTests(dataTestId, 'badgeTW')}
    className={classNames('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', className)}
  >
    {children}
  </span>
);

/*
 * a Badge that expects its background and text color to be passed in the className prop
 * */
export const ColorBadgeTW: FCWithChildren<{ className?: string }> = ({ children, className }) => {
  if (!className) return null;
  return (
    <span className={classNames('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', className)}>
      {children}
    </span>
  );
};
